import React, { useContext, useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import { DataContext } from '../contexts/DataContext';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const PaymentAdvancesPerCustomerChart = () => {
  const { paymentAdvances } = useContext(DataContext);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  useEffect(() => {
    const customerAdvances = paymentAdvances.reduce((acc, advance) => {
      // Check if customer_data and customer_name are defined
      if (advance.customer_data && advance.customer_data.customer_name) {
        const { customer_name } = advance.customer_data;
        acc[customer_name] = (acc[customer_name] || 0) + 1;
      } else {
        // Handle cases where customer_name is not defined
        // You might want to categorize these under a generic label like 'Unknown'
        const unknownCustomer = 'Unknown';
        acc[unknownCustomer] = (acc[unknownCustomer] || 0) + 1;
      }
      return acc;
    }, {});

    setChartData({
      labels: Object.keys(customerAdvances),
      datasets: [
        {
          label: 'Number of Payment Advances',
          data: Object.values(customerAdvances),
          backgroundColor: 'rgba(54, 162, 235, 0.6)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1,
        },
      ],
    });
  }, [paymentAdvances]);

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: false, // Change to true if you wish to display the legend
      },
    },
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big flex flex-col justify-between">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartBar} className="text-blue-600 mr-2" />
          Payment Advances per Customer
        </h2>
      </div>
      <div className="flex-grow">
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default PaymentAdvancesPerCustomerChart;
